import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/pricing`;

export const pricing = {
  plans: {
    getById: async ({ planAreas, accountId } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${accountId}/draws`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data: planAreas,
      });
      return apiRequest(options);
    },
  },
  options: {
    getById: async ({ planAreas, accountId }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${accountId}/options/draws`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data: planAreas,
      });
      return apiRequest(options);
    },
    getAll: async ({ planId, params }) => {
      const options = await apiOptions({
        url: `${HOME_SERVICE}/pricing/plans/${planId}/options-draws`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        params,
      });
      return apiRequest(options);
    },
  },
  pricingAdjustment: {
    getPriceDetails: async ({ planId, accountId } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/plans/${planId}/draws`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        params: { accountId },
      });
      return apiRequest(options);
    },
    getAll: async ({ planId, pricingAdjustmentId } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${planId}/pricing-adjustments/${pricingAdjustmentId}`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
    create: async ({ accountId, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/adjustments/${accountId}`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
    update: async ({ pricingAdjustmentId, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/adjustments/${pricingAdjustmentId}`,
        method: "patch",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
    delete: async ({
      pricingAdjustmentId,
      modifiedOn,
      toastMessageConfig,
    } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/adjustments/${pricingAdjustmentId}`,
        method: "delete",
        headers: { [X_API_VERSION]: API_VERSION },
        data: { modifiedOn },
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
